// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Jackpot Bottom Band CSS Module
 * PERFORMANCE OPTIMIZED: Eliminates styled-components runtime computation
 * Uses data attributes for jackpot-specific styling
 */
.ZoqDiiONV5Zjf8rXQd3A {
  font-family: var(--font-family-quaternary, 'Roboto');
  font-weight: 800;
  pointer-events: none;
  text-align: center;
  width: 100%;
  color: #fff;
  font-variant-numeric: tabular-nums;
  border-radius: 0 0 var(--border-radius-for-game-cards, 5px) var(--border-radius-for-game-cards, 5px);
  height: var(--jp-bottom-band-height, 20px);
  background: #126e51;
  /* default jackpot color */
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}
@media (max-width: 1024px) {
  .ZoqDiiONV5Zjf8rXQd3A[data-view='multi'] {
    height: 24px;
  }
}
/* Jackpot-specific backgrounds using data attributes */
.ZoqDiiONV5Zjf8rXQd3A[data-jackpot="high_rtp"] {
  background: linear-gradient(180deg, #DC7B21, #AF4016);
}
.ZoqDiiONV5Zjf8rXQd3A[data-jackpot="bell_link"] {
  background: linear-gradient(180deg, #0c6e17, #075710);
}
.ZoqDiiONV5Zjf8rXQd3A[data-jackpot="vip_bell_link"] {
  background: linear-gradient(180deg, #a00500, #7c0500);
}
.ZoqDiiONV5Zjf8rXQd3A[data-jackpot="gods_and_kings"] {
  background: linear-gradient(180deg, #0c6e17, #075710);
}
.ZoqDiiONV5Zjf8rXQd3A[data-jackpot="vip_gods_and_kings"] {
  background: linear-gradient(180deg, #a00500, #7c0500);
}
.ZoqDiiONV5Zjf8rXQd3A[data-jackpot="high_cash"],
.ZoqDiiONV5Zjf8rXQd3A[data-jackpot="vip_high_cash"] {
  background: linear-gradient(180deg, #6238cc, #472797);
}
.ZoqDiiONV5Zjf8rXQd3A[data-jackpot="clover_chance"] {
  background: linear-gradient(180deg, #046ce5, #0040b9);
}
.ZoqDiiONV5Zjf8rXQd3A[data-jackpot="instantlink"] {
  background: linear-gradient(180deg, #ba0059, #860041);
}
/* Single Progressive Jackpot Colors */
.ZoqDiiONV5Zjf8rXQd3A[data-jackpot="rise_of_ra"] {
  background: linear-gradient(180deg, #d8a500, #b28d00);
}
.ZoqDiiONV5Zjf8rXQd3A[data-jackpot="20_super_hot"] {
  background: linear-gradient(180deg, #fc415a, #c31524);
}
.ZoqDiiONV5Zjf8rXQd3A[data-jackpot="40_super_hot"] {
  background: linear-gradient(180deg, #4b98ff, #2c68ac);
}
.ZoqDiiONV5Zjf8rXQd3A[data-jackpot="burning_hot"] {
  background: linear-gradient(180deg, #3dbe40, #4d7e01);
}
.ZoqDiiONV5Zjf8rXQd3A[data-jackpot="versailles_gold"] {
  background: linear-gradient(180deg, #ed6002, #c74004);
}
.a8RpYRRQcN4v68ueaLYB {
  background: linear-gradient(180deg, #01abaf, #067e81);
  font-family: var(--font-family-secondary);
  color: #ffffff;
  letter-spacing: 0.6px;
}
.BU3PcxMJBeAqGrKEZemd {
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
  height: 100%;
  width: 100%;
}
.RdhDDBMY5RC_Dqc1AX8i {
  display: inline-flex;
  align-items: baseline;
}
.UctjoX0nrvl11O0MzTQY {
  font-variant-numeric: tabular-nums;
  font-family: var(--font-family-numeric);
  font-weight: 100;
  text-align: center;
  font-size: calc(var(--jp-bottom-band-height, 24px) * 0.85);
  min-width: 0;
  letter-spacing: 0;
  font-feature-settings: "tnum" 1;
}
.UctjoX0nrvl11O0MzTQY[data-jackpot="high_rtp"] {
  font-family: var(--font-family-secondary);
  font-weight: 800;
  letter-spacing: 0.6px;
}
@media (max-width: 1024px) {
  .UctjoX0nrvl11O0MzTQY[data-view='multi'] {
    font-size: calc(24px * 0.85);
  }
}
/* Debug: Visual verification of font loading */
.UctjoX0nrvl11O0MzTQY::before {
  content: attr(data-font-test);
  position: absolute;
  opacity: 0;
  pointer-events: none;
}
.oXYNcHoVTbQmOuWKAl4t {
  font-family: var(--font-family-secondary) !important;
  text-transform: uppercase;
  white-space: nowrap;
  padding-left: 2px;
  font-size: var(--jp-bottom-band-font-size, 17px);
  letter-spacing: 0.7px;
  font-weight: 900;
}
@media (max-width: 1024px) {
  .oXYNcHoVTbQmOuWKAl4t {
    font-size: 9px;
  }
}
@media (min-height: 500px) {
  [data-view='single'][data-section='pickRandom'] .ZoqDiiONV5Zjf8rXQd3A {
    height: 34px;
  }
  [data-view='single'][data-section='pickRandom'] .UctjoX0nrvl11O0MzTQY {
    font-size: calc(34px * 0.85);
  }
  [data-view='single'][data-section='pickRandom'] .oXYNcHoVTbQmOuWKAl4t {
    font-size: 17px;
  }
}
@media (min-width: 1025px) {
  [data-game-card-size="compact"] .ZoqDiiONV5Zjf8rXQd3A {
    height: 24px;
  }
  [data-game-card-size="compact"] .UctjoX0nrvl11O0MzTQY {
    font-size: calc(24px * 0.85);
  }
  [data-game-card-size="compact"] .oXYNcHoVTbQmOuWKAl4t {
    font-size: 9px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/games/components/GameCard/components/JackpotBottomBand/JackpotBottomBand.module.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;EACE,oDAAoD;EACpD,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,kCAAkC;EAClC,oGAAoG;EACpG,0CAA0C;EAC1C,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;AACV;AACA;EACE;IACE,YAAY;EACd;AACF;AACA,uDAAuD;AACvD;EACE,qDAAqD;AACvD;AACA;EACE,qDAAqD;AACvD;AACA;EACE,qDAAqD;AACvD;AACA;EACE,qDAAqD;AACvD;AACA;EACE,qDAAqD;AACvD;AACA;;EAEE,qDAAqD;AACvD;AACA;EACE,qDAAqD;AACvD;AACA;EACE,qDAAqD;AACvD;AACA,sCAAsC;AACtC;EACE,qDAAqD;AACvD;AACA;EACE,qDAAqD;AACvD;AACA;EACE,qDAAqD;AACvD;AACA;EACE,qDAAqD;AACvD;AACA;EACE,qDAAqD;AACvD;AACA;EACE,qDAAqD;EACrD,yCAAyC;EACzC,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;EAClC,YAAY;EACZ,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,kCAAkC;EAClC,uCAAuC;EACvC,gBAAgB;EAChB,kBAAkB;EAClB,0DAA0D;EAC1D,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;AACA;EACE,yCAAyC;EACzC,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE;IACE,4BAA4B;EAC9B;AACF;AACA,+CAA+C;AAC/C;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,oDAAoD;EACpD,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,gDAAgD;EAChD,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,cAAc;EAChB;AACF","sourcesContent":["/**\n * Jackpot Bottom Band CSS Module\n * PERFORMANCE OPTIMIZED: Eliminates styled-components runtime computation\n * Uses data attributes for jackpot-specific styling\n */\n.jackpotBand {\n  font-family: var(--font-family-quaternary, 'Roboto');\n  font-weight: 800;\n  pointer-events: none;\n  text-align: center;\n  width: 100%;\n  color: #fff;\n  font-variant-numeric: tabular-nums;\n  border-radius: 0 0 var(--border-radius-for-game-cards, 5px) var(--border-radius-for-game-cards, 5px);\n  height: var(--jp-bottom-band-height, 20px);\n  background: #126e51;\n  /* default jackpot color */\n  white-space: nowrap;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n@media (max-width: 1024px) {\n  .jackpotBand[data-view='multi'] {\n    height: 24px;\n  }\n}\n/* Jackpot-specific backgrounds using data attributes */\n.jackpotBand[data-jackpot=\"high_rtp\"] {\n  background: linear-gradient(180deg, #DC7B21, #AF4016);\n}\n.jackpotBand[data-jackpot=\"bell_link\"] {\n  background: linear-gradient(180deg, #0c6e17, #075710);\n}\n.jackpotBand[data-jackpot=\"vip_bell_link\"] {\n  background: linear-gradient(180deg, #a00500, #7c0500);\n}\n.jackpotBand[data-jackpot=\"gods_and_kings\"] {\n  background: linear-gradient(180deg, #0c6e17, #075710);\n}\n.jackpotBand[data-jackpot=\"vip_gods_and_kings\"] {\n  background: linear-gradient(180deg, #a00500, #7c0500);\n}\n.jackpotBand[data-jackpot=\"high_cash\"],\n.jackpotBand[data-jackpot=\"vip_high_cash\"] {\n  background: linear-gradient(180deg, #6238cc, #472797);\n}\n.jackpotBand[data-jackpot=\"clover_chance\"] {\n  background: linear-gradient(180deg, #046ce5, #0040b9);\n}\n.jackpotBand[data-jackpot=\"instantlink\"] {\n  background: linear-gradient(180deg, #ba0059, #860041);\n}\n/* Single Progressive Jackpot Colors */\n.jackpotBand[data-jackpot=\"rise_of_ra\"] {\n  background: linear-gradient(180deg, #d8a500, #b28d00);\n}\n.jackpotBand[data-jackpot=\"20_super_hot\"] {\n  background: linear-gradient(180deg, #fc415a, #c31524);\n}\n.jackpotBand[data-jackpot=\"40_super_hot\"] {\n  background: linear-gradient(180deg, #4b98ff, #2c68ac);\n}\n.jackpotBand[data-jackpot=\"burning_hot\"] {\n  background: linear-gradient(180deg, #3dbe40, #4d7e01);\n}\n.jackpotBand[data-jackpot=\"versailles_gold\"] {\n  background: linear-gradient(180deg, #ed6002, #c74004);\n}\n.jackpotGameLabelCrashGame {\n  background: linear-gradient(180deg, #01abaf, #067e81);\n  font-family: var(--font-family-secondary);\n  color: #ffffff;\n  letter-spacing: 0.6px;\n}\n.valueContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  white-space: nowrap;\n  font-variant-numeric: tabular-nums;\n  height: 100%;\n  width: 100%;\n}\n.contentWrapper {\n  display: inline-flex;\n  align-items: baseline;\n}\n.dynamicText {\n  font-variant-numeric: tabular-nums;\n  font-family: var(--font-family-numeric);\n  font-weight: 100;\n  text-align: center;\n  font-size: calc(var(--jp-bottom-band-height, 24px) * 0.85);\n  min-width: 0;\n  letter-spacing: 0;\n  font-feature-settings: \"tnum\" 1;\n}\n.dynamicText[data-jackpot=\"high_rtp\"] {\n  font-family: var(--font-family-secondary);\n  font-weight: 800;\n  letter-spacing: 0.6px;\n}\n@media (max-width: 1024px) {\n  .dynamicText[data-view='multi'] {\n    font-size: calc(24px * 0.85);\n  }\n}\n/* Debug: Visual verification of font loading */\n.dynamicText::before {\n  content: attr(data-font-test);\n  position: absolute;\n  opacity: 0;\n  pointer-events: none;\n}\n.currency {\n  font-family: var(--font-family-secondary) !important;\n  text-transform: uppercase;\n  white-space: nowrap;\n  padding-left: 2px;\n  font-size: var(--jp-bottom-band-font-size, 17px);\n  letter-spacing: 0.7px;\n  font-weight: 900;\n}\n@media (max-width: 1024px) {\n  .currency {\n    font-size: 9px;\n  }\n}\n@media (min-height: 500px) {\n  [data-view='single'][data-section='pickRandom'] .jackpotBand {\n    height: 34px;\n  }\n  [data-view='single'][data-section='pickRandom'] .dynamicText {\n    font-size: calc(34px * 0.85);\n  }\n  [data-view='single'][data-section='pickRandom'] .currency {\n    font-size: 17px;\n  }\n}\n@media (min-width: 1025px) {\n  [data-game-card-size=\"compact\"] .jackpotBand {\n    height: 24px;\n  }\n  [data-game-card-size=\"compact\"] .dynamicText {\n    font-size: calc(24px * 0.85);\n  }\n  [data-game-card-size=\"compact\"] .currency {\n    font-size: 9px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"jackpotBand": `ZoqDiiONV5Zjf8rXQd3A`,
	"jackpotGameLabelCrashGame": `a8RpYRRQcN4v68ueaLYB`,
	"valueContainer": `BU3PcxMJBeAqGrKEZemd`,
	"contentWrapper": `RdhDDBMY5RC_Dqc1AX8i`,
	"dynamicText": `UctjoX0nrvl11O0MzTQY`,
	"currency": `oXYNcHoVTbQmOuWKAl4t`
};
export default ___CSS_LOADER_EXPORT___;
